module.exports = __webpack_public_path__ + "static/diogenes-97a380ff561a1b39281afa24dd4c6225.png";